/**
 * Env 类型化校验（七横-类型 + 七横-部署环境）
 * 启动时调一次 getEnv()，缺 key 立即抛错
 *
 * 注意：必须用具体键名访问 import.meta.env.X，不能整体传入，
 * 否则 Vike SSR 会把它替换为 null（tree-shaking 安全考量）
 */
import { z } from 'zod';

const envSchema = z.object({
  VITE_CF_ANALYTICS_TOKEN: z.string().default(''),
  VITE_GA4_ID: z.string().default(''),
  VITE_POSTHOG_KEY: z.string().default(''),
  VITE_POSTHOG_HOST: z.string().default('https://app.posthog.com'),
  VITE_TURNSTILE_SITE_KEY: z.string().default(''),
  VITE_TERMLY_UUID: z.string().default(''),
  VITE_SENTRY_DSN: z.string().default(''),
  VITE_API_BASE_URL: z.string().default(''),
});

export type Env = z.infer<typeof envSchema>;

let cached: Env | null = null;

export function getEnv(): Env {
  if (cached) return cached;
  cached = envSchema.parse({
    VITE_CF_ANALYTICS_TOKEN: import.meta.env.VITE_CF_ANALYTICS_TOKEN,
    VITE_GA4_ID: import.meta.env.VITE_GA4_ID,
    VITE_POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY,
    VITE_POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST,
    VITE_TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY,
    VITE_TERMLY_UUID: import.meta.env.VITE_TERMLY_UUID,
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  });
  return cached;
}
